import { components, type GroupBase, type InputProps } from 'react-select';

export function SelectInput(
  props: InputProps<unknown, boolean, GroupBase<unknown>>,
) {
  const {
    selectProps: { 'aria-describedby': ariaDescribedBy },
  } = props as typeof props & {
    readonly selectProps: {
      readonly 'aria-describedby'?: string;
    };
  };

  return <components.Input {...props} aria-describedby={ariaDescribedBy} />;
}
